module.exports = __webpack_public_path__ + "img/diashow (1).03ccc75.jpg";